import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navigation.css';
import { useLanguage } from '../contexts/LanguageContext';

interface NavigationProps {
  scrolled: boolean;
}

const Navigation: React.FC<NavigationProps> = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useLanguage();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-brand">
          <img src="/waymining_icon_simple.png" alt="Waymining FMS" className="brand-icon" />
          <span className="brand-text">Waymining FMS</span>
        </div>
        
        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <button onClick={() => scrollToSection('home')}>{t('nav.home')}</button>
          <button onClick={() => scrollToSection('features')}>{t('nav.features')}</button>
          <button onClick={() => scrollToSection('management-center')}>{t('nav.modules')}</button>
          <button onClick={() => scrollToSection('benefits')}>{t('nav.benefits')}</button>
          <button onClick={() => scrollToSection('technology')}>{t('nav.technology')}</button>
          <button onClick={() => scrollToSection('contact')}>{t('nav.contact')}</button>
          <Link to="/" className="nav-company-link">{t('nav.company')}</Link>

          <button className="nav-cta">{t('hero.button.start')}</button>
        </div>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;